import { useState } from "react";
import clone from "../../../../../components/controllers/shared/clone/clone";
import { useGlobalContext } from "../../../../global/state";

export const useSettings = () => {
	const { data } = useGlobalContext();
	const initial = clone(data.settings);
	const original = clone(data.settings);
	const [settings, setSettings] = useState(initial);

	const updateSettings = {
		accountOverview: (
			experience: "member" | "employer",
			value: boolean,
		) => {
			const newSettings = clone(settings);
			newSettings.accountOverview[experience].selected = value;
			setSettings(newSettings);
		},
		reset: () => {
			setSettings(original);
		},
	};

	return { settings, updateSettings };
};
